(function () {
  'use strict';

  /* Add lp-js class immediately to enable CSS animations */
  document.body.classList.add('lp-js');

  /* ── Scroll reveal ────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.lp-reveal');
    if (!els.length) return;
    var timer = setTimeout(function () {
      els.forEach(function (el) { el.classList.add('lp-revealed'); });
    }, 2000);
    if (!window.IntersectionObserver) {
      clearTimeout(timer);
      els.forEach(function (el) { el.classList.add('lp-revealed'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('lp-revealed');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ── Live social proof toasts ─────────────────────────── */
  function initSocialProof() {
    var notifications = [
      'Jessica from Texas just purchased Rainbow Splash.',
      'Marcus from Georgia added Boys Locs to cart.',
      'Brittany from Louisiana purchased two for brother and sister.',
      'Amara from Florida just ordered the 4-pack.',
      'Jasmine from Ohio got matching caps for her girls.',
      'Keisha from Atlanta just purchased Bubblegum Dream.',
      'DeShawn from Houston added Boys Locs Cap to cart.',
      'Tanisha from Dallas purchased for swim lessons.',
      'Priya from Tampa ordered Rainbow Splash.',
      'Maya from Chicago got the Buy 2 Get 1 Free deal.'
    ];

    var container = document.createElement('div');
    container.id = 'sh-toast-container';
    container.style.cssText = 'position:fixed;bottom:100px;left:16px;z-index:9990;display:flex;flex-direction:column-reverse;gap:8px;pointer-events:none;';
    document.body.appendChild(container);

    function showToast(msg) {
      var toast = document.createElement('div');
      toast.style.cssText = 'background:#102A43;color:#fff;padding:12px 16px;border-radius:12px;font-family:Inter,sans-serif;font-size:0.82rem;font-weight:600;max-width:240px;box-shadow:0 4px 20px rgba(16,42,67,0.4);border-left:3px solid #2BAAE2;opacity:0;transform:translateX(-20px);transition:opacity .4s,transform .4s;pointer-events:auto;';
      toast.innerHTML = '<div style="font-size:0.65rem;color:#B7F3E4;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;margin-bottom:4px">Recent Purchase</div>' + msg;
      container.appendChild(toast);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          toast.style.opacity = '1';
          toast.style.transform = 'translateX(0)';
        });
      });
      setTimeout(function () {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-20px)';
        setTimeout(function () { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
      }, 4000);
    }

    var idx = 0;
    setTimeout(function () {
      showToast(notifications[idx % notifications.length]);
      idx++;
      setInterval(function () {
        showToast(notifications[idx % notifications.length]);
        idx++;
      }, Math.random() * 4000 + 8000);
    }, 6000);
  }

  /* ── FAQ accordion ────────────────────────────────────── */
  function initFaq() {
    document.querySelectorAll('.lp-faq__item').forEach(function (item) {
      var btn = item.querySelector('.lp-faq__q');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('lp-open');
        document.querySelectorAll('.lp-faq__item').forEach(function (i) { i.classList.remove('lp-open'); });
        if (!isOpen) item.classList.add('lp-open');
      });
    });
  }

  /* ── Bar chart ────────────────────────────────────────── */
  function initChart() {
    var fills = document.querySelectorAll('.lp-bar__fill');
    if (!fills.length) return;
    if (!window.IntersectionObserver) {
      fills.forEach(function (b) { b.style.width = b.dataset.width; }); return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelectorAll('.lp-bar__fill').forEach(function (b) {
            setTimeout(function () { b.style.width = b.dataset.width; }, 80);
          });
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.lp-chart').forEach(function (el) { obs.observe(el); });
  }

  /* ── Smooth scroll for anchor links ──────────────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ── Init ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initSocialProof();
    initFaq();
    initChart();
    initSmoothScroll();
  });

})();
